import React from 'react';
import 'prismjs/themes/prism.css';

import '../global-styles';
import userConfig from '../../config';

import Header from '../components/Header';
import GlobalStyle from '../global-styles';

class Template extends React.Component {
  render() {
    const { children, curLocation } = this.props;
    return (
      <div>
        <GlobalStyle />
        <Header config={userConfig} curLocation={curLocation}/>
        {children}
      </div>
    );
  }
}

export default Template;
